module.exports = __webpack_public_path__ + "img/Screen Shot 2021-01-04 at 15.52.33.f1dd7672.png";